module.exports = __webpack_public_path__ + "img/credit-card.f0ebd9fa.svg";